module.exports = __webpack_public_path__ + "img/1106e_1.dfefdd01.jpg";